<template>
  <span>
    <v-btn fab large dark color="primary" @click="onClick">
      <v-icon>photo</v-icon>
    </v-btn>
    <input type="file" accept=",application/pdf,image/*" style="display:none"
      ref="fileInput"
      @change="fileSelected"
    >
  </span>
</template>

<script>
  export default {
    name: 'upload-button',
    props: {
      selectedCallback: Function,
      id: Number
    },
    methods: {
      onClick () {
        this.$refs.fileInput.click();
      },
      fileSelected (event) {
        const files = event.target.files
        var filename = files[0].name
        if (filename.lastIndexOf('.') <= 0) {
          return alert('Please add a valid file!')
        }
        const fileReader = new FileReader()
        fileReader.addEventListener('load', () => {
          this.imageUrl = fileReader.result
        })
        fileReader.readAsDataURL(files[0])
        this.image = files[0]

        if (this.selectedCallback) {
          if (event.target.files[0]) {
            this.selectedCallback(this.image);
          } else {
            this.selectedCallback(null);
          }
        }
      }
    }
  }
</script>

<style scoped>

</style>
